import React from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import EngagementModalChart from "./EngagementModalChart";
import moment from "moment-timezone";
import ModalPostCardData from "./ModalPostCardData";
import "./EngagementModal.scss";

import { Popup } from "semantic-ui-react";

import { ReactComponent as InfoIcon } from "../../../../assets/svg/info-icon.svg";
const EngagementModal = (props) => {
    return (
        <Modal className="engagemnet-modal" show={props.open} onClose={() => props.hideModal()} noSkipGTranslate={true}>
            <Modal.Header className="engagemnet-header">
                Engagement over Time
                <Popup
                    inverted
                    className=" engagemnet skiptranslate"
                    size="tiny"
                    position="right center"
                    content="Displays the total engagement in real time."
                    trigger={<InfoIcon className="info__icon" />}
                    style={{ zIndex: 9999999, backgroundColor: "#112C5A", width: "600px" }}
                    //  open ={true}
                />
            </Modal.Header>
            <Modal.Content className="engagemnet-modal-container" noSkipGTranslate={true}>
                <section className="engagemnet-post-container">
                    <ModalPostCardData
                        data={props.modalPostCardData}
                        postData={props.postData}
                        downloadParentPostCsv={props.downloadParentPostCsv}
                        setPostSentiment={props.setPostSentiment}
                        setCommentSentiment={props.setCommentSentiment}
                        company={props.company}
                        postIndex={props.postIndex}
                        updatePostAfterSentimentUpdate={props.updatePostAfterSentimentUpdate}
                    />
                </section>
                <section className="charts skiptranslate">{props.data && <EngagementModalChart data={props.data} />}</section>
            </Modal.Content>
        </Modal>
    );
};

export default EngagementModal;
